'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdPermIdentity = function MdPermIdentity(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 21.6q2.5 0 5.5 0.7t5.4 2.4 2.5 3.7v5h-26.8v-5q0-2.1 2.5-3.7t5.4-2.4 5.5-0.7z m0-15q2.7 0 4.7 2t1.9 4.8-1.9 4.6-4.7 2-4.7-2-1.9-4.6 1.9-4.8 4.7-2z m0 18.2q-3.4 0-6.8 1.3t-3.4 2.3v1.8h20.4v-1.8q0-1-3.4-2.3t-6.8-1.3z m0-15q-1.5 0-2.5 1.1t-1 2.5 1 2.4 2.5 1 2.5-1 1-2.4-1-2.5-2.5-1.1z' })
        )
    );
};

exports.default = MdPermIdentity;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/perm-identity.js
// module id = ./node_modules/react-icons/lib/md/perm-identity.js
// module chunks = 0